import React from 'react';
import { Link } from 'react-router-dom';

export default function AppFooter() {
  return (
    <footer className="app-footer">
      <div className="footer-links">
        <Link to="/legal">Legal</Link>
        <Link to="/settings">Settings</Link>
        <a href="https://alpaca.markets" target="_blank" rel="noopener noreferrer">Alpaca</a>
        <a href="https://polygon.io" target="_blank" rel="noopener noreferrer">Polygon.io</a>
      </div>
      <p>Informational and educational use only. Paper trading unless a live brokerage connection is explicitly enabled.</p>
    </footer>
  );
}
